import {
  signInWithPopup,
  GoogleAuthProvider,
  signOut,
  onAuthStateChanged,
} from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { auth, db } from "./config";

// Check if email is in the allowed admins list in Firestore
const checkAdminAccess = async (email) => {
  try {
    const adminDoc = await getDoc(doc(db, "admins", email.toLowerCase()));
    return adminDoc.exists();
  } catch (error) {
    console.error("Error checking admin access:", error);
    return false;
  }
};

// Sign in with Google
export const signInWithGoogle = async () => {
  const provider = new GoogleAuthProvider();
  provider.setCustomParameters({
    prompt: "select_account",
  });

  const result = await signInWithPopup(auth, provider);

  // Check if email is allowed
  const isAllowed = await checkAdminAccess(result.user.email);
  if (!isAllowed) {
    await signOut(auth);
    throw new Error("unauthorized");
  }

  return result.user;
};

// Sign out
export const logOut = async () => {
  await signOut(auth);
};

// Subscribe to auth state changes
export const onAuthChange = (callback) => {
  return onAuthStateChanged(auth, callback);
};

// Get current user
export const getCurrentUser = () => {
  return auth.currentUser;
};
